<script setup>
const fullWidthMode = inject("fullWidthMode", false);
const halfCol = computed(() => (fullWidthMode ? undefined : 6));
// 용어해석 - 천간 & 지지
import { VCard, VCol, VRow } from 'vuetify/lib/components/index.mjs';
import KeywordExplanation from './KeywordExplanation.vue';
import BasicContentsTitle from './BasicContentsTitle.vue';
</script>

<template>
  <VRow class="ss-full-height">
    <VCol cols="12" :md="halfCol" class="ss-full-height">
      <div class="summ-card right">
        <BasicContentsTitle
          number="1"
          text="<span>사주,&nbsp;</span><span>이제는 나도 이해할 수 있어요</span>"
        />
        <section class="summ-body">
          <KeywordExplanation
            chn="天"
            tit="천간"
            subtit="하늘의 기운을 뜻합니다."
            :desc="[
              '일간을 포함한 사주 구성의 절반을 차지합니다.',
              '<b>열 가지 종류</b>가 있고, 사람마다 어떤 천간을 타고났는지가 달라요.',
            ]"
            :bottom="['갑목은 우직한 큰 나무, 정화는 은은한 촛불처럼 각각의 성질을 가지고 있어요.']"
            :ex-string="true"
          />
          <div class="summ-img summ-img--cheongan">
            <img src="@manseImages/saju-summary/img_summary_cheongan.png" alt="천간 요약 이미지" />
          </div>
        </section>
      </div>
    </VCol>
    <VCol cols="12" :md="halfCol" class="ss-full-height">
      <div class="summ-card">
        <section class="summ-body">
          <KeywordExplanation
            chn="地"
            tit="지지"
            subtit="땅의 기운을 뜻합니다."
            :desc="[
              '각각의 동물 띠(쥐·소·호랑이 등)와 계절, 시간의 흐름을 담고 있습니다.',
              '<b>열두 가지 종류</b>가 있으며, 일간과의 관계에 따라 다양한 감정과 흐름이 나타나요.',
            ]"
            :bottom="['자수는 겨울의 물, 오화는 여름의 불처럼 계절과 자연의 이미지를 담고 있어요.']"
            :ex-string="true"
          />
          <div class="summ-img summ-img--jiji">
            <img src="@manseImages/saju-summary/img_summary_jiji.png" alt="지지 요약 이미지" />
          </div>
        </section>
      </div>
    </VCol>
  </VRow>
</template>
